var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2041_228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.978 6.36426L13.5153 5.57383L11.075 0.660547C10.8548 0.222656 10.4257 0 10.0003 0C9.57497 0 9.1496 0.218945 8.92945 0.660547L6.48915 5.57383L1.02647 6.36426C0.0451236 6.50527 -0.346668 7.70391 0.366019 8.39043L4.31751 12.2127L3.38094 17.6121C3.24662 18.3803 3.86602 19 4.56005 19C4.74289 19 4.93318 18.9555 5.11602 18.859L10.0041 16.3096L14.8884 18.859C15.0712 18.9555 15.2578 18.9963 15.4406 18.9963C16.1347 18.9963 16.7541 18.3803 16.6235 17.6084L15.6906 12.209L19.6421 8.38672C20.3511 7.7002 19.9593 6.50156 18.9817 6.36055L18.978 6.36426ZM14.4369 10.9361L13.7615 11.5893L13.922 12.5133L14.6496 16.7252L10.8399 14.7361L10.0041 14.302V2.53086L11.9071 6.36426L12.325 7.20293L13.2578 7.33652L17.519 7.95254L14.4332 10.9361H14.4369Z",
    fill: "#F67924"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2041_228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.b58a9c995bba00ec424ff84815853487.svg";
export { ForwardRef as ReactComponent };